import componentKeys from "@/helpers/wc/componentKeys";
import defaultPosition from "@/helpers/wc/positionSettings";

export const panel = {
  title: 'Panel',
  [componentKeys.name]: 'panelBase',

  [componentKeys.styles]: {
    ...defaultPosition,
    [componentKeys.bgColor]: 'transparent',
    [componentKeys.borderWidth]: '0px',
    [componentKeys.borderStyle]: 'none',
    [componentKeys.borderColor]: "transparent",
    [componentKeys.borderRadius]: '0px',
  },
  [componentKeys.properties]: {}
};
